import DescriptionOnlyFormValues from "../ReusableFormValues/DescriptionOnlyFormValues";
import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import { form990DocumentTypesArray } from "./constants";

interface Props {
  readonly: boolean;
}

const Form990FormValues = ({ readonly }: Props) => {
  return (
    <>
      <SubTypeDocumentSelector
        readonly={readonly}
        subTypeDocuments={form990DocumentTypesArray}
        placeholder="Select a form 990 document type"
        name="secondaryDocumentType"
        label="Document sub-type"
      />
      <DescriptionOnlyFormValues readonly={readonly} />
    </>
  );
};

export default Form990FormValues;
